// extracted by mini-css-extract-plugin
export default {"requirements":"requirements--2QS9R","title":"title--LB8Rb"};